// Stripe Connect Service for Customer Portal
// V2 API - Updated for Stripe Connect V2

// Shared singleton — same session as the rest of the portal; avoids an extra
// GoTrueClient instance. functions.invoke works with or without a session.
import { supabase } from '../utils/supabaseClient';

/**
 * Create a checkout session for invoice payment (V2 API - Direct Charges)
 */
export async function createCheckoutSession({ amount, companyId, customerId, invoiceId, jobId, jobTitle, description, customerEmail, paymentType, workOrderId }) {
  // Amount should be in cents
  const amountInCents = Math.round(amount * 100);

  const { data, error } = await supabase.functions.invoke('stripe-create-checkout', {
    method: 'POST',
    body: {
      amount: amountInCents,
      companyId,
      customerId,
      invoiceId,
      jobId,
      jobTitle,
      description,
      customerEmail,
      ...(paymentType && { paymentType }),
      ...(workOrderId && { workOrderId }),
    },
  });

  if (error) {
    console.error('Error creating checkout session:', error);
    throw new Error(error.message || 'Failed to create checkout session');
  }

  return data;
}

/**
 * Get invoice details
 */
export async function getInvoice(invoiceId) {
  const { data, error } = await supabase
    .from('invoices')
    .select(`
      *,
      company:companies(id, name, stripe_account_id, stripe_onboarding_complete),
      customer:customers(id, name, email, phone)
    `)
    .eq('id', invoiceId)
    .single();

  if (error) {
    console.error('Error fetching invoice:', error);
    throw new Error(error.message || 'Failed to fetch invoice');
  }

  return data;
}

/**
 * Redirect to Stripe Checkout
 */
export function redirectToCheckout(sessionUrl) {
  if (sessionUrl) {
    window.location.href = sessionUrl;
  } else {
    throw new Error('No checkout URL provided');
  }
}

/**
 * Format amount for display
 */
export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}
